/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { registerField } from 'core/forms';

import FormFieldEditorMediumWrapper from './formFieldEditorMediumWrapper';

import styles from '../styles/formFieldInlineEditor.module.scss';

import 'medium-editor/dist/css/medium-editor.css';
import 'medium-editor/dist/css/themes/default.css';

const FormFieldInlineEditor = ({
  fieldId,
  schema,
  updateField,
}) => (
  <div className={styles.element}>
    {schema.options.editors.map((editor) => (
      <FormFieldEditorMediumWrapper
        id={fieldId}
        key={editor.id}
        tag={editor.tag}
        text={editor.text}
        onChange={updateField}
        onKeyDown={editor.onKeyDown}
        options={editor.options}
      />
    ))}
  </div>
);

FormFieldInlineEditor.defaultProps = {
  fieldId: '',
  schema: {
    options: {
      editors: [],
    },
  },
  updateField: () => {},
};

FormFieldInlineEditor.propTypes = {
  fieldId: PropTypes.string,
  schema: PropTypes.shape({
    options: PropTypes.shape({
      editors: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
  updateField: PropTypes.func,
};
registerField('InlineEditors', React.memo(FormFieldInlineEditor));

export default FormFieldInlineEditor;
